import React, { useMemo } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import "../../styles/Auth/store.css";

const sanitizeValue = (val, isMulti) => {
    if (isMulti) {
        if (!Array.isArray(val)) return [];
        return val.filter(
            (v) =>
                v &&
                typeof v === "object" &&
                v.value !== undefined &&
                v.label !== undefined
        );
    } else {
        if (Array.isArray(val)) return val[0] || null;
        if (val && typeof val === "object" && val.value !== undefined) return val;
        return null;
    }
};

const CategorySelect = ({
    value,
    onChange,
    loadCategories,
    isMulti = false,
    placeholder = "Select Category",
    onAddCategory,
    loggedInRole
}) => {
    const safeValue = useMemo(() => sanitizeValue(value, isMulti), [value, isMulti]);

    return (
        <AsyncPaginate
            isMulti={isMulti}
            value={safeValue}
            loadOptions={async (search, loadedOptions, additional) => {
                const res = await loadCategories(search, loadedOptions, additional);
                let options = res?.options || [];

                // ➕ ADD CATEGORY OPTION
                if (onAddCategory && additional.page === 1) {
                    options.unshift({
                        value: "__ADD_CATEGORY__",
                        label: "+ Add Category",
                        style: { color: 'blue', fontWeight: 'bold' }
                    });
                }

                return {
                    ...res,
                    options
                };
            }}
            onChange={(val) => {
                const selected = sanitizeValue(val, isMulti);
                if (isMulti) {
                    if (selected?.some(v => v.value === "__ADD_CATEGORY__")) {
                        if (onAddCategory) onAddCategory();
                        return;
                    }
                } else {
                    if (selected?.value === "__ADD_CATEGORY__") {
                        if (onAddCategory) onAddCategory();
                        return;
                    }
                }
                onChange(selected);
            }}
            placeholder={placeholder}
            additional={{ page: 1 }}
            menuPortalTarget={document.body}
            styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                    ...base,
                })
            }}
        />
    );
};

export default CategorySelect;

